import { createAsyncThunk } from '@reduxjs/toolkit'
import { AddIpAddressEntry, EditIpAddressEntry, DeleteIpAddressEntry } from '@lk/api'

import { actions as LKActions } from '../../../features/shared/LKModal'
import { ThunkApi } from '../../index.d'

export const addIpAddress = createAsyncThunk<void, AddIpAddressEntry, ThunkApi>(
  '[SECURITY] ADD_IP_ADDRESS',
  async (params, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.security.addIpAddress(params)

    if (result.success) {
      return result.data
    }

    dispatch(LKActions.openError(result.error.message))

    return rejectWithValue(result.error.message)
  },
)

export const editIpAddress = createAsyncThunk<void, EditIpAddressEntry, ThunkApi>(
  '[SECURITY] EDIT_IP_ADDRESS',
  async (params, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.security.editIpAddress(params)

    if (result.success) {
      return result.data
    }

    dispatch(LKActions.openError(result.error.message))

    return rejectWithValue(result.error.message)
  },
)

export const deleteIpAddress = createAsyncThunk<void, DeleteIpAddressEntry, ThunkApi>(
  '[SECURITY] Delete_IP_ADDRESS',
  async (params, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.security.deleteIpAddress(params)

    if (result.success) {
      return result.data
    }

    dispatch(LKActions.openError(result.error.message))

    return rejectWithValue(result.error.message)
  },
)
